<template>
  <div class="loading-parent">
    <loading :active.sync="isLoading"
             :is-full-page="fullPage"></loading>
  </div>
</template>

<script>

  import {GlobalEudoxusBus} from "../../js/DistributionRequestService";
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.min.css';

  export default {
    name: "loading-component",
    data() {
      return {
        isLoading: false,
        fullPage: true,
        modalShow: false
      }
    },
    components: {
      'loading': Loading
    },
    created() {
      GlobalEudoxusBus.$on("toggleLoading", flag => {
        if (flag)
          this.isLoading = true;
        else
          this.isLoading = false;
      });
    }
  }
</script>

<style scoped>

  .loading-parent {
    position: relative;
  }

  .loader {
    margin-left: 45%;
    border: 4px solid #324851;
    border-right-color: #fff;
    border-left-color: #fff;
    border-radius: 50%;
    width: 30px;
    height: 30px;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
</style>



// WEBPACK FOOTER //
// src/components/LoadingModalComponent/LoadingComponent.vue